<template>
  <Layout :is-loading="isLoading">
    <div class="bloco">
      <HeaderPage :page-titles="pageTitles" :hide-button="true" />
      <b-input-group>
        <b-form-input
          id="filter"
          v-model="config.email"
          type="text"
          placeholder="Email"
        ></b-form-input>

        <v-select
        v-model="config.obra"
          dir="auto"
          class="v-select vs__search vs--single vs--searchable"
          style="margin-top: 0px; border-top-width: 0px"
          placeholder="Obra"
          :options="obras"
          label="nome"
        ></v-select>

        <b-input-group-append>
          <b-button @click="adicionar">Adicionar</b-button>
        </b-input-group-append>
      </b-input-group>

      <div class="mt-5">
        <Table
          :search="true"
          :tables-fields="grupoFields"
          :table-items="configs"
          @onEdit="edit"
          @onDelete="onDelete"
        />
      </div>
    </div>
  </Layout>
</template>
<script>
import Layout from '@layouts/main'
import HeaderPage from '@/src/components/register/header-page.vue'
import Table from '@/src/components/tables/table-register.vue'
import alertMixin from '@/src/mixins/alertMixin'
import configService from '../../../../services/config'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import obraService from '@src/services/serviceObra'
export default {
  components: { Layout, HeaderPage, Table, 'v-select': vSelect },
  mixins: [alertMixin],
  data() {
    return {
      obras: [],
      isLoading: false,
      pageTitles: {
        title: 'Alerta de Estoque',
        subTitle: 'Configure os emails para recebimento de alertas de estoque',
        currentPage: 1,
        perPage: 20,
      },
      grupoFields: [
        {
          key: 'email',
          label: 'E-mail',
          class: 'size-col-200',
        },
        {
          key: 'obra.nome',
          label: 'Obra',
          class: 'size-col-200',
        },
        { key: 'actions', label: '', class: 'size-col-10' },
      ],
      configs: [],
      config: {},
    }
  },
  mounted() {
    this.lista()
    this.obrasSelect()
  },

  methods: {
    updateByFiliais(){
    this.lista()
    this.obrasSelect()
    },
    obrasSelect(){
      obraService.list(this.$store.state.filter,this.$store.state.filial ).then(res =>{
        this.obras = res.data.data
            console.log(this.obras, 'this.obras')
        }
        )

    },

    lista() {
      this.isLoading = true
      configService
        .list(this.$store.state.filter, this.$store.state.filial)
        .then((res) => {
          const { data } = res.data
          this.configs = data
          this.isLoading = false
        })
    },
    adicionar() {
      this.isLoading = true
      if (!this.config._id) {
        configService
          .create(this.config)
          .then((res) => {
           console.log(this.config, "import { Schema as schema, Document } from 'mongoose';")
            this.isLoading = false
            this.config = {}
            this.successMessage('E-mail adicionado com sucesso')
            this.lista()
          })
          .catch((err) => {
            this.errorMessage(err.message)
            this.isLoading = false
          })
        return
      }
      configService
        .update(this.config._id, this.config)
        .then((res) => {
          this.successMessage('E-mail atualizado com sucesso')
          this.config = {}
          this.lista()
          this.isLoading = false
        })
        .catch((err) => {
          this.errorMessage(err.message)
          this.isLoading = false
        })
    },
    edit(item) {
      this.config = item
    },
    onDelete(id) {
      this.isLoading = true
      configService
        .remove(id)
        .then((res) => {
          this.isLoading = false
          this.lista()
          this.successMessage('E-mail removido com sucesso')
          this.config = {}
        })
        .catch((err) => {
          this.errorMessage(err.message)
          this.isLoading = false
        })
    },
  },
}
</script>
<style src="../style.scss" lang="scss"></style>
